import PropTypes from 'prop-types';

export const stylePropType = PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array
]);
export const btnPropType = PropTypes.shape({
    backgroundColor: PropTypes.string,
    border: PropTypes.string,
    color: PropTypes.string
});

export const childrenPropType = PropTypes.oneOfType([PropTypes.node, PropTypes.func]);
export const componentStylePropTypes = PropTypes.shape({
    contentBgColor: PropTypes.string,
    contentBorderRadius: PropTypes.number,
    titleFontWeight: PropTypes.number,
    titleColor: PropTypes.string,
    descColor: PropTypes.string,
    answerColor: PropTypes.string,
    optionColor: PropTypes.string,
    optionLabelColor: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonLabelColor: PropTypes.string,
    buttonSize: PropTypes.string
});
